import type { DashboardMetric } from "./types";

export const dashboardMetrics: DashboardMetric[] = [
  { label: "Total Revenue", value: "Rs 12,80,450" },
  { label: "Orders Today", value: "47" },
  { label: "Pending Shipments", value: "19" },
  { label: "Low Stock Items", value: "8" },
];

export const recentActivities = [
  "New order #NSJ2205 placed by Priya Sharma.",
  'Product "Kundan Choker Set" stock updated.',
  "Refund initiated for order #NSJ2193.",
  "New customer account created: ananya@email.com.",
];
